module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAA4AAAAOCAYAAAAfSC3RAAAACXBIWXMAAAsTAAALEwEAmpwYAAAAAXNSR0IArs4c6QAAAARnQU1BAACxjwv8YQUAAADYSURBVHgBlVExDsIwDHQQI4gZHlB2XtAPMLKVlW9UDKzMwAf4QB8AGwMVM/1AZ9SNJZylpDLBUelJJyeOz74khgSstQnCnL7xBm/GmJdMmkB4RGgcPVbgA8K1rB3SL84oKkWzGcIEMUd+6/MD+g8HvgLEmz5Ctp3zVHAHcdZaxSaVlWzLLfcg2xu5febX/o5JMOUKjnGnRkzlhu3Lao8jJy/d8o4mtTyLCdnBVOx5YrcQ3U/UAU2Yur+LOak0YQEuHDWw5UsoTMGnUlzCekERq3xQk45KS34AdEVCPnf/KfQAAAAASUVORK5CYII="


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/m2.png
// module id = 6L8o
// module chunks = 1